import React from 'react';
import PropTypes from 'prop-types';
import Nav from '@/components/Nav';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { List } from '@material-ui/core';
import { Route, Switch } from 'react-router-dom';

import Exercises from './components/Exercises';
import ExerciseConfig from './components/ExerciseConfig';
import AdminLogs from './components/AdminLogs';
import UserList from './components/UserList';
import AffiliatePlans from './components/AffiliatePlans';
import Affiliates from './components/Affiliates';
import Organizations from './components/Organizations';
import Overview from './components/Overview';
import CheckoutSessions from './components/CheckoutSessions';
import UserSessions from './components/UserSessions';
import Funnels from './components/Funnels';
import Collections from './components/Collections';
import InformationItems from './components/InformationItems';
import HomeConfig from './components/HomeConfig';

import './Admin.styles.scss';

const routes = [
  {
    path: 'overview',
    title: 'Overview',
    component: Overview,
  },
  {
    path: 'user-list',
    title: 'UserList',
    component: UserList,
  },
  {
    path: 'funnels',
    title: 'Funnels',
    component: Funnels,
  },
  {
    path: 'checkout-sessions',
    title: 'CheckoutSessions',
    component: CheckoutSessions,
  },
  {
    path: 'user-sessions',
    title: 'UserSessions',
    component: UserSessions,
  },
  {
    path: 'exercises',
    title: 'Exercises',
    component: Exercises,
  },
  {
    path: 'exercises-config',
    title: 'ExerciseConfig',
    component: ExerciseConfig,
  },
  {
    path: 'admin-logs',
    title: 'AdminLogs',
    component: AdminLogs,
  },
  {
    path: 'affiliate-plans',
    title: 'AffiliatePlans',
    component: AffiliatePlans,
  },
  {
    path: 'affiliates',
    title: 'Affiliates',
    component: Affiliates,
  },
  {
    path: 'organizations',
    title: 'Organizations',
    component: Organizations
  },
  {
    path: 'collections',
    title: 'Collections',
    component: Collections,
  },
  {
    path: 'information-items',
    title: 'InformationItems',
    component: InformationItems,
  },
  {
    path: 'home-config',
    title: 'HomeConfig',
    component: HomeConfig,
  },
];

const Admin = ({ controller }) => (
  <div className="Admin">
    <title>Admin</title>
    <Nav>
      <div className="Admin-content">
        <div className="liner">
          <div className="picker">
            <List>
              {routes.map((route) => (
                <ListItem
                  key={route.path}
                  button
                  onClick={() => controller.onScreenPress(route.path)}
                >
                  <ListItemText primary={route.title} />
                </ListItem>
              ))}
            </List>
          </div>
          <div className="screens">
            <div className="liner">
              <Switch>
                {routes.map((route) => (
                  <Route
                    key={route.path}
                    path={`/admin/${route.path}`}
                    exact
                    component={route.component}
                  />
                ))}
              </Switch>
            </div>
          </div>
        </div>
      </div>
    </Nav>
  </div>
);

Admin.propTypes = {
  controller: PropTypes.shape({
    onScreenPress: PropTypes.func.isRequired,
  }).isRequired,
};

export default Admin;
